/** Column widths (px) for Theo dõi VTPT thu hồi on-page tables. */
export const THU_HOI_COLUMN_WIDTHS = {
  /** Checkbox select column */
  select: 36,
  stt: 36,
  ma: 70,
  ten: 140,
  dvt: 44,
  /** Date value `dd/mm/yyyy` */
  ngay: 78,
  /**
   * Numeric quantity — up to 5 digits (+ separators/decimals), e.g. `12,345.67`.
   * Headers wrap within this width.
   */
  soLuong: 72,
  /**
   * Free-text fields (`Diễn giải`, `Ghi chú`) — sized for readable wrap
   * of long strings (up to 255 chars), not full character width.
   */
  text: 200,
} as const;
